import { useQuery } from "@tanstack/react-query";

import { getCanDoShop } from "../core/shopUser.core";

export default function useCanDoShop(cap?: ShopCap) {
  const rst = useQuery({
    queryKey: ["canDoShop", cap],
    queryFn: () => getCanDoShop(cap!),
    enabled: cap !== null && cap !== undefined,
  });

  if (!cap) return true;

  if (rst.failureReason) {
    console.error(rst.failureReason);
  }

  if (!rst.isFetched) return null;
  if (rst.isFetched) return rst.data;
}
